import { HttpEvent, HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { Observable } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { AuthService } from './auth.service';

export const authInterceptor = (
  req: HttpRequest<unknown>,
  next: HttpHandlerFn,
): Observable<HttpEvent<unknown>> => {
  const authService = inject(AuthService);

  return authService.getToken().pipe(
    switchMap((token) => {
      if (token) {
        // Clone the request and add the Authorization header
        req = req.clone({
          headers: req.headers.set('Authorization', 'Bearer ' + token),
        });
      }

      return next(req);
    }),
  );
};
